const {
    TextOperators
} = require('./text');

const {
    NumberOperators
} = require('./number');

const {
    DateOperators
} = require('./date');

const {
    YesOrNoOperators
} = require('./yesOrNo');

const {
    ListOperators
} = require('./list');

const {
    FileOperators
} = require('./file');

const OperatorsMap = {
    text: TextOperators,
    multiline: TextOperators,
    number: NumberOperators,
    date: DateOperators,
    list: ListOperators,
    yesOrNo: YesOrNoOperators,
    dropdownSelect: ListOperators,
    multiSelect: ListOperators,
    radioSelect: ListOperators,
    file: FileOperators
};
module.exports = {
    OperatorsMap
}